(function ($) {
	/**
	 * Update cookie
	 */
	function to_location_customer_init() {
		var region_display_cookie = Cookies.get("shippingZone");
		var location = $(".wcpbc-country-switcher").val();

		var country = ["AU", "AT", "GB", "AX", "other"];

		if (!country.includes(location)) {
			location = "";
		}

		// Lightbox
		var cloneRegions = $(".shipping-region").clone();

		cloneRegions.addClass("column-display");

		cloneRegions.find("a").each(function (index) {
			$(this).parent().css({ display: "" });
		});

		$("#country-popup .popup-content").append(cloneRegions);

		console.log(region_display_cookie);

		if (
			region_display_cookie == undefined ||
			region_display_cookie == "" ||
			location == undefined ||
			location == ""
		) {
			// openLighbox();
		} else if (region_display_cookie == "GB") {
			openRedirectLightDBRepresent();
		} else if (region_display_cookie == "AX") {
			var popupSALE = Cookies.get("popupSALEUSA");

			if (popupSALE == undefined || popupSALE == "") {
				Cookies.set("popupSALEUSA", "1", { path: "/" });
				openSalePopup();
			}
		}

		$(".shipping-region .shipping-zone-region").on("click", function (e) {
			e.preventDefault();

			var that = $(this);
			Cookies.set("shippingZone", that.parent().data("country"), {
				path: "/",
			});

			var first = $(".wcpbc-country-switcher:first");

			first.val(that.parent().data("country"));
			first.trigger("change");
		});
	}

	function to_location_mobile_init() {
		$(".location-selected-item").on("click", function () {
			// openLighbox();
		});
	}

	function openLighbox() {
		// Open directly via API
		$.magnificPopup.open({
			items: {
				src: "#country-popup", // can be a HTML string, jQuery object, or CSS selector
				type: "inline",
			},
			closeOnBgClick: false,
			showCloseBtn: false,
		});
	}

	function openRedirectLightDBRepresent() {
		// Open directly via API
		function directPopupClose() {
			var magnificPopup = $.magnificPopup.instance; // save instance in magnificPopup variable
			magnificPopup.close();
		}

		$.magnificPopup.open({
			items: {
				src:
					'<div class="white-popup direct-popup"><div class="popup-content"><p>From now on, <span class="graden-furniture">The Garden Furniture Centre</span> will represent <span class="color-purge">Think Outside</span> in United Kingdom, for any order or inquiry please contact Jon Haimes on <a href="tel:01564793652">01564 793 652</a> or <a href="mailto:jon@gardenfurniturecentre.co.uk">jon@gardenfurniturecentre.co.uk</a></p><div class="direct-popup-footer">' +
					'<a class="et_pb_button et_pb_button_0 et_pb_bg_layout_light btn-reset-location">BUY FROM OTHER LOCATION</a><br/>' +
					'<a class="et_pb_button et_pb_button_0 et_pb_bg_layout_light" href="https://www.gardenfurniturecentre.co.uk/thinkoutside.html">CLICK HERE TO CONTINUE</a></div></div></div>',
				type: "inline",
			},
			closeOnBgClick: true,
			showCloseBtn: true,
			callbacks: {
				open: () => {
					$(".btn-reset-location").on("click", directPopupClose);
				},
				afterClose: () => {
					sessionStorage.removeItem("shippingZone");
					openLighbox();
				},
			},
		});
	}

	function initHTML() {
		var innerHTML = "";
		var selectUI = "";
		var region_display_cookie = Cookies.get("shippingZone");

		if (region_display_cookie == undefined || region_display_cookie == "") {
			$(".wcpbc-country-switcher").val("AX").trigger("change");
			$(
				'#wcpbc-widget-country-switcher-form input[name="wcpbc-manual-country"]'
			).val("AX");
			$("#wcpbc-widget-country-switcher-form").submit();
			Cookies.set("shippingZone", "AX", {
				path: "/",
			});
		}

		var region_display = $(".wcpbc-country-switcher").val();

		if (customer_config.regions) {
			$.each(customer_config.regions, function (idx, elm) {
				if (idx == "europe") {
					return true;
				}

				if (region_display == elm["countries"][0]) {
					innerHTML +=
						'<li data-value="' +
						idx +
						'" data-country="' +
						elm["countries"][0] +
						'" style="display: none;"><a href="" class="shipping-zone-region flag-' +
						elm["countries"][0] +
						'">' +
						elm["name"] +
						"</a></li>";
				} else {
					innerHTML +=
						'<li data-value="' +
						idx +
						'" data-country="' +
						elm["countries"][0] +
						'"><a href="" class="shipping-zone-region flag-' +
						elm["countries"][0] +
						'">' +
						elm["name"] +
						"</a></li>";
				}

				if (region_display == elm["countries"][0]) {
					selectUI +=
						'<span class="flag-' +
						region_display +
						'">' +
						elm["name"] +
						"</span>";
				}
			});

			// innerHTML += '<li data-country="other"><a href="" class="shipping-zone-region flag-other">Other</a></li>';
		}

		if (selectUI == "") {
			selectUI +=
				'<span class="flag-' + region_display + '">Other</span>';
		}

		$(".guest-location.nav").append(
			"<ul><li>" +
				selectUI +
				'<ul class="shipping-region">' +
				innerHTML +
				"</ul></li></ul>"
		);
	}

	$(document).ready(function () {
		initHTML();
		to_location_mobile_init();
		to_location_customer_init();
	});
})(jQuery);
